import React from 'react';

/**
 * Minimal loading screen component
 * @param {string} message - Loading message to display
 * @param {boolean} fullScreen - Whether to show full screen or inline
 */
const LoadingScreen = ({ message = 'Loading...', fullScreen = true }) => {
  const containerClass = fullScreen 
    ? 'fixed inset-0 bg-black flex items-center justify-center z-50'
    : 'flex items-center justify-center py-20';

  return (
    <div className={containerClass}>
      <div className="flex flex-col items-center gap-4">
        {/* Simple spinner */}
        <div className="w-10 h-10 border-2 border-gray-700 border-t-white rounded-full animate-spin"></div>
        
        {/* Loading text with subtle animated dots */}
        <div className="flex items-center gap-1">
          <span className="text-gray-400 text-base">{message}</span>
          <div className="flex gap-1">
            <span className="w-1 h-1 bg-gray-500 rounded-full animate-pulse" style={{ animationDelay: '0ms' }}></span>
            <span className="w-1 h-1 bg-gray-500 rounded-full animate-pulse" style={{ animationDelay: '200ms' }}></span>
            <span className="w-1 h-1 bg-gray-500 rounded-full animate-pulse" style={{ animationDelay: '400ms' }}></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;

